<div class="contents">
  <div class="dm-page-content mb-25">
    <div class="container-fluid">
      <div class="toRight">
        <app-search-bar [showPrimaryBtn]="false" [showFilterBtn]="true" (onFilterBtnClick)="showFilter = true">
        </app-search-bar>
      </div>

      <div class="row mt-3">
        <ng-container *ngIf="pagination?.data?.length; else noGrupos">
          <app-table [pagination]="pagination" [columns]="columns" [actions]="actions"
            (pageChange)="onPageChange($event)" (rowClick)="getDetalhe($event)">
          </app-table>
        </ng-container>

        <ng-template #noGrupos>
          <div class="no-data">
            <app-data-void titulo="Nenhum registo encontrado" descricao="Tente novamente mais tarde.">
            </app-data-void>
          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <p-dialog header="Detalhes do registo" [modal]="true" [(visible)]="showDetalhe" [style]="{ width: '50rem' }"
    appendTo="body">
    <form class="p-fluid grid" [formGroup]="formLog">
      <div class="field col-6">
        <h4>Utilizador</h4>
        <input type="text" pInputText formControlName="nome" class="w-full" />
      </div>
      <div class="field col-6">
        <h4>Email</h4>
        <input type="text" pInputText formControlName="email" class="w-full" />
      </div>
      <div class="field col-6">
        <h4>Acção</h4>
        <input type="text" pInputText formControlName="acao" class="w-full" />
      </div>
      <div class="field col-3">
        <h4>Data</h4>
        <input type="text" pInputText formControlName="dataFormata" class="w-full" />
      </div>
      <div class="field col-3">
        <h4>Resultado</h4>
        <input type="text" pInputText formControlName="sucesso" class="w-full" />
      </div>

      <div class="field col-12 mt-2">
        <h4>PayLoad(JSON)</h4>

        <article>
          <app-json-tree [data]="jsonLog"></app-json-tree>
        </article>
      </div>
    </form>
    <div class="flex items-center justify-content-between">
      <p-button label="Cancelar" severity="secondary" (click)="showDetalhe = false" />
      <p-button label="Fechar" (click)="showDetalhe = false" />
    </div>
  </p-dialog>

  <p-dialog header="Filtros" [modal]="true" [(visible)]="showFilter" [style]="{ width: '40rem' }" appendTo="body">
    <form [formGroup]="form" class="p-fluid grid">
      <div *ngFor="let filter of filters" class="field col-6 d-flex flex-column">
        <label>{{ filter.placeholder }}</label>

        <!-- Se for dropdown -->
        <p-select *ngIf="filter.type === 'dropdown'" [filter]="true" [showClear]="true" appendTo="body"
          [options]="filter.options" [formControlName]="filter.controlName" [placeholder]="filter.placeholder"
          [optionLabel]="filter.optionLabel" [optionValue]="filter.optionValue">
        </p-select>

        <!-- Se for texto -->
        <input *ngIf="filter.type === 'text'" pInputText [formControlName]="filter.controlName"
          [placeholder]="filter.placeholder" class="w-full" />

        <!-- Se for data -->
        <p-datepicker *ngIf="filter.type === 'date'" appendTo="body" [showIcon]="true"
          [formControlName]="filter.controlName" [showTime]="true" [placeholder]="filter.placeholder"
          class="w-full d-grid">
        </p-datepicker>
      </div>
    </form>

    <div class="flex items-center justify-content-between">
      <p-button label="Cancelar" severity="secondary" (click)="showFilter = false" />
      <p-button label="Pesquisar" (click)="handleFormValueChange(form.value)" />
    </div>
  </p-dialog>
</div>

<p-toast></p-toast>